// Thin wrapper around the Tournament Engine endpoints exposed by
// /app/backend/tournament_engine.py. Mirrors the eventApi.js pattern.
import axios from 'axios';
import { tokenStore } from './api';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const tournamentAPI = {
  // Tournaments
  list: () => client.get('/tournaments'),
  get: (id) => client.get(`/tournaments/${id}`),
  create: (payload) => client.post('/tournaments', payload),
  update: (id, payload) => client.patch(`/tournaments/${id}`, payload),
  remove: (id) => client.delete(`/tournaments/${id}`),
  restore: (id) => client.post(`/tournaments/${id}/restore`),

  // Flyer (Phase T2.0A Prompt 2)
  uploadFlyer: (id, file) => client.post(`/tournaments/${id}/flyer`, file, {
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
  }),
  deleteFlyer: (id) => client.delete(`/tournaments/${id}/flyer`),

  // Entries
  addEntry: (id, payload) => client.post(`/tournaments/${id}/entries`, payload),
  updateEntry: (id, entryId, payload) =>
    client.patch(`/tournaments/${id}/entries/${entryId}`, payload),
  removeEntry: (id, entryId) =>
    client.delete(`/tournaments/${id}/entries/${entryId}`),
  replacePlayer: (id, entryId, body) =>
    client.post(`/tournaments/${id}/entries/${entryId}/replace-player`, body),

  // Seeds
  setSeeds: (id, seeds) => client.put(`/tournaments/${id}/seeds`, { seeds }),

  // Bracket
  generateBracket: (id) => client.post(`/tournaments/${id}/generate-bracket`),
  resetBracket: (id) => client.post(`/tournaments/${id}/reset-bracket`),

  // Matches
  recordResult: (id, matchId, payload) =>
    client.post(`/tournaments/${id}/matches/${matchId}/result`, payload),
  clearMatch: (id, matchId) =>
    client.post(`/tournaments/${id}/matches/${matchId}/clear`),
  updateSchedule: (id, matchId, payload) =>
    client.patch(`/tournaments/${id}/matches/${matchId}/schedule`, payload),
};

export const TOURNAMENT_STATUS_LABELS = {
  draft: 'Draft',
  registration_open: 'Registration open',
  registration_closed: 'Registration closed',
  bracket_generated: 'Bracket generated',
  in_progress: 'In progress',
  completed: 'Completed',
  archived: 'Archived',
};
